webpackJsonp([35783957827783],{

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexStyled = _styledComponents2.default.section.withConfig({
	  displayName: 'pages__IndexStyled',
	  componentId: 'sc-1u8mhwl-0'
	})(['display:grid;grid-auto-flow:row;grid-template:52px 100px 100px 1fr / auto;height:100%;background-color:transparent;.index__title{grid-area:1 / 1 / 2 /-1;z-index:1;}.index__subtitle{grid-area:2 / 1 / 3 /-1;z-index:1;}.index__tagline1{grid-area:3 / 1 / 4 /-1;z-index:1;}.index__tagline2{grid-area:4 / 1 / -1 /-1;z-index:1;}.index__news a{display:inline-flex;align-items:center;min-height:24px;padding:0.2rem 0;}']);
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    IndexStyled,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Home - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'Home'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__title' },
	      'My name is Roberto V\xE1zquez Gonz\xE1lez.'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__subtitle' },
	      'I\xB4m an organized and enthusiastic ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        'Full-stack Software Engineer'
	      ),
	      ' with',
	      _react2.default.createElement(
	        'mark',
	        null,
	        ' 15+ years of experience'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__tagline1' },
	      'I work across the entire stack, from infrastructure and DevOps to backend,',
	      ' ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        'frontend and UI/UX'
	      ),
	      ', where my passion naturally lies.'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__tagline2' },
	      _react2.default.createElement(
	        'mark',
	        null,
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'love' },
	          '\uD83D\uDC9B'
	        ),
	        ' ',
	        'ts,',
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'parenting' },
	          ' ',
	          '\uD83D\uDC68\u200D\uD83C\uDF7C'
	        ),
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'surf' },
	          '\uD83C\uDFC4\u200D'
	        ),
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'meditation' },
	          '\uD83E\uDDD8\u200D'
	        ),
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'guitar' },
	          '\uD83C\uDFB8'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__news' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'This is where I share my projects, thoughts and the tools I enjoy using:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        data.allMarkdownRemark.edges.map(function (_ref2) {
	          var post = _ref2.node;
	          return _react2.default.createElement(
	            'li',
	            { key: post.id },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { key: post.id, to: post.frontmatter.path },
	              post.frontmatter.title
	            )
	          );
	        })
	      )
	    )
	  );
	};
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	/**
	 * Prop types
	 */
	IndexPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	IndexPage.defaultProps = {
	  data: {
	    allMarkdownRemark: {
	      edges: []
	    }
	  }
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a06bf4e089c2026cf75f.js